import { createContext, useContext } from 'react'

/**
 * Which family of threads the communications components are showing. Supplier (PO, invoice and
 * quote) threads use `/dashboard/communications/*`; customer threads (USA-1328) keep their own
 * tables and use the same-shaped `/dashboard/customer-communications/*` routes.
 */
export type ThreadMailbox = 'supplier' | 'customer'

const ThreadMailboxContext = createContext<ThreadMailbox>('supplier')

/** Wrap a customer thread so the shared thread components call the customer endpoints. */
export const ThreadMailboxProvider = ThreadMailboxContext.Provider

export function useThreadMailbox(): ThreadMailbox {
  return useContext(ThreadMailboxContext)
}
